import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { AuditModule } from '@app/modules/audit';
import { AuditIcon } from '@app/modules/audit/components/AuditIcon';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { StationsBreadcrumbs } from '../../../../../../components/base/stations/StationsBreadcrumbs';
import { Page } from '../../../../../../components/page/Page';
import { getAuditStationHeaderLinks } from '../../components/StationLinks';
import { SchedulesViewView } from './SchedulesViewView';

export function SchedulesViewPage() {
  const station = useActiveStation();
  const { scheduleId } = useParams<{ scheduleId: string }>();
  const { $t } = useIntl();

  if (!scheduleId) {
    return null;
  }

  const title = $t(
    {
      id: 'audit.schedulesViewScreen.title',
      defaultMessage: `Schedule #{id}`,
    },
    { id: scheduleId },
  );

  return (
    <Page htmlTitle={`${title} / ${station.name}`}>
      <Page.Header
        icon={<AuditIcon />}
        title={$t({
          id: 'audit.sidenav.stationAudit',
          defaultMessage: 'Audit de emisora',
        })}
        tabs={getAuditStationHeaderLinks(station, $t)}
        breadcrumbs={
          <StationsBreadcrumbs
            basePath={AuditModule.basePath}
            activeId={station.id}
            items={[
              {
                content: title,
                active: true,
              },
            ]}
          />
        }
      />
      <Page.Content>
        <SchedulesViewView station={station} scheduleId={scheduleId} />
      </Page.Content>
    </Page>
  );
}
